import React from 'react';
import KQ from '../images/kqherself.jpg';
import KQContainer from './KQContainer';

export function About() {
    return (
        <div className="p-4">
            <h1 className="text-center mb-4">About Me</h1>
            <div className="row h-auto">
                <div className="col-xl mx-auto">
                    <KQContainer customCss="bg-secondary">
                        <p className="mt-0 p-0">I am a 34 year old transgender woman and software developer presently based out of Hamilton, Ontario, but willing to move for the right opportunity.</p>
                        <p className="p-0">I pride myself on my work ethic, professionalism, organization, and drive to learn and improve.</p>
                        <p className="mb-0 p-0">I am currently looking to pick up French again, as well as various certifications within the programming and development world.</p>
                    </KQContainer>
                    <KQContainer customCss="bg-accent mt-4 mb-1 mb-xl-0">
                        <p className="mt-0 p-0">In my spare time, I...</p>
                        <ul className="mb-0 py-0">
                            <li key="about-spare-1">Write music and play instruments, primarily guitar - currently working on recording a cover album</li>
                            <li key="about-spare-2">Started my own game development business - currently a sole proprietorship, to become a LLC</li>
                            <li key="about-spare-3">Look for opportunities to learn and improve, whether it be from online courses or books such 
                                as <a href="https://itrevolution.com/the-phoenix-project/" className="link-dark" target="_blank" rel="noopener noreferrer">The Phoenix Project</a> and 
                                <a href="https://www.joshwaitzkin.com/the-art-of-learning" className="link-dark" target="_blank" rel="noopener noreferrer">The Art of Learning</a>
                            </li>
                        </ul>
                    </KQContainer>
                </div>
                <div className="col-xl mx-auto h-auto mt-4 mt-xl-0 text-center">
                    <img src={KQ} alt="A picture of Kara Quinn" className="img-fluid rounded shadow mb-2" />
                </div>
            </div>
            <KQContainer customCss="bg-secondary mb-4 mt-4">
                <p className="mt-0 p-0">
                    It took me a while to figure out what I wanted to do with my life. I settled on software development after fiddling 
                    around with codecademy where I discovered an interest in programming.
                </p>
                <p className="mb-0 p-0">
                    Software Development did not come naturally at first, but ultimately I graduated from Mohawk College with a decently high average 
                    because I was willing to put in the work to improve rather than get complacent. It wasn't a straightforward path by any means, 
                    but it was a period of growth and one of which I am proud.
                </p>
            </KQContainer>
        </div>
    );
}